<template>
  <div id="RequestInfo" class="request-info-card">
    <div class="request-info-header">
      <h5 class="section-title mb-0">Thông tin yêu cầu</h5>
      <span class="request-status-badge" :class="getStatusClass(requestInfo.status)">
        {{ requestInfo.status || "-" }}
      </span>
    </div>

    <div class="request-info-body">
      <div class="request-overview-grid">
        <div class="info-panel">
          <span class="info-label">Người đề xuất</span>
          <div class="info-value">{{ requestInfo.requester_name || "-" }}</div>
        </div>
        <div class="info-panel">
          <span class="info-label">Số điện thoại liên hệ</span>
          <div class="info-value">{{ requestInfo.phone || "-" }}</div>
        </div>
        <div class="info-panel">
          <span v-if="requestInfo.type == 0" class="info-label">Phòng ban</span>
          <span v-else class="info-label">Cơ sở yêu cầu</span>
          <div class="info-value">{{ departmentOrFacility || "-" }}</div>
        </div>
        <div class="info-panel">
          <span class="info-label">Thời gian</span>
          <div class="info-value">{{ timeDisplay || "-" }}</div>
        </div>
      </div>

      <div class="request-products-section">
        <div class="section-head">
          <div>
            <h6 class="mb-1">Sản phẩm và số lượng</h6>
            <p class="section-subtitle mb-0">Danh sách vật tư trong yêu cầu logistics</p>
          </div>
        </div>

        <div v-if="requestProducts.length > 0" class="table-responsive mt-3">
          <table class="table table-bordered table-vertical-center mb-0 request-products-table">
            <thead class="bg-light">
              <tr>
                <th class="text-left align-middle">Sản phẩm</th>
                <th class="text-left align-middle product-qty-col">Số lượng</th>
                <th v-if="requestInfo.type == 0" class="text-left align-middle product-price-col">Giá sản phẩm</th>
                <th v-if="requestInfo.type == 0" class="text-left align-middle product-total-col">Tổng tiền</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product in requestProducts" :key="product.id || product.product_name">
                <td class="align-middle">
                  <div class="product-name">{{ product.product_name || "-" }}</div>
                </td>
                <td class="align-middle">{{ product.quantity }}</td>
                <td v-if="requestInfo.type == 0" class="align-middle">{{ formatCurrency(product.unit_price || 0) }}</td>
                <td v-if="requestInfo.type == 0" class="align-middle font-weight-bold text-dark">
                  {{ formatCurrency(getProductTotal(product)) }}
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="requestInfo.type == 0" class="request-total-wrap">
            <span class="request-total-label">Tổng tiền:</span>
            <span class="request-total-value">{{ formatCurrency(totalAmount) }}</span>
          </div>
        </div>

        <div v-else class="empty-products-state mt-3">
          Chưa có sản phẩm
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RequestInfo",
  props: {
    requestInfo: {
      type: Object,
      default() {
        return {
          requester_name: "",
          phone: "",
          department_name: "",
          facility_name: "",
          name: "",
          month: "",
          request_time: "",
          products: [],
          status: "",
        };
      },
    },
  },
  computed: {
    departmentOrFacility() {
      return this.requestInfo.department_name || this.requestInfo.facility_name || "";
    },
    timeDisplay() {
      return this.requestInfo.request_time || this.requestInfo.month || this.requestInfo.name || "";
    },
    requestProducts() {
      return this.requestInfo.products || [];
    },
    totalAmount() {
      return this.requestProducts.reduce(
        (sum, product) => sum + this.getProductTotal(product),
        0
      );
    },
  },
  methods: {
    formatCurrency(value) {
      const numericValue = Number(value);
      return `${new Intl.NumberFormat("vi-VN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(Number.isNaN(numericValue) ? 0 : numericValue)} VND`;
    },
    getProductTotal(product) {
      return (Number(product.quantity) || 0) * (Number(product.unit_price) || 0);
    },
    getStatusClass(status) {
      const statusClasses = {
        "Chưa tiếp nhận": "bg-gray",
        "Đang xử lý": "bg-yellow",
        "Đã cung cấp đủ hàng": "bg-blue",
        "Đã nhận hàng": "bg-teal",
        "Hoàn thành": "bg-green",
        Hủy: "bg-danger-soft",
      };
      return statusClasses[status] || "bg-gray";
    },
  },
};
</script>

<style scoped>
.request-info-card {
  border: 1px solid #e8edf4;
  border-radius: 16px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.request-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #edf2f7;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
}

.request-info-body {
  padding: 18px 20px 20px;
}

.request-overview-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.info-panel {
  min-height: 72px;
  padding: 10px 14px;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  background: #fafcff;
}

.info-label {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 8px;
}

.info-value {
  margin-top: 6px;
  color: #1f2937;
  font-size: 15px;
  line-height: 1.45;
  word-break: break-word;
}

.request-products-section {
  margin-top: 18px;
  padding: 20px;
  border: 1px solid #e9eef5;
  border-radius: 16px;
  background: #ffffff;
}

.section-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}

.section-subtitle {
  color: #718096;
  font-size: 13px;
}

.request-products-table th,
.request-products-table td {
  padding: 14px 16px;
  vertical-align: middle;
}

.product-name {
  font-weight: 600;
  color: #1f2937;
}

.product-qty-col {
  width: 120px;
}

.product-price-col,
.product-total-col {
  width: 160px;
}

.request-total-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  font-size: 16px;
}

.request-total-label {
  font-weight: 700;
  color: #1f2937;
}

.request-total-value {
  font-weight: 800;
  color: #e53e3e;
}

.empty-products-state {
  padding: 24px;
  border-radius: 14px;
  text-align: center;
  background: #f8fafc;
  color: #94a3b8;
}

.request-status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  border: 1px solid transparent;
}

.bg-yellow {
  background: #fff3cd;
  color: #8a5a00;
  border-color: #ffe08a;
}

.bg-gray {
  background: #eef1f5;
  color: #5f6b7a;
  border-color: #d7dee7;
}

.bg-teal {
  background: #e6fffb;
  color: #0f8b82;
  border-color: #9be7df;
}

.bg-danger-soft {
  background: #fdecec;
  color: #d14343;
  border-color: #f6bcbc;
}

.request-status-badge.bg-blue {
  background: #e8f1ff;
  color: #0b63f6;
  border-color: #b8d2ff;
}

.request-status-badge.bg-green {
  background: #e9f9ee;
  color: #14833b;
  border-color: #b7e4c7;
}

.section-title {
  color: #0f172a;
  font-size: 16px;
}

@media screen and (max-width: 991px) {
  .request-overview-grid {
    grid-template-columns: 1fr;
  }

  .section-head {
    flex-direction: column;
  }
}

@media screen and (max-width: 767px) {
  .request-info-body {
    padding: 14px;
  }

  .request-products-section {
    padding: 14px;
  }
}
</style>
